import React from "react";

function Card(props) {
  return (
    <div className="flex flex-col md:flex-row gap-3 items-center justify-center text-center md:text-left bg-white rounded-xl overflow-clip p-5 mb-5 md:w-3/4   shadow-xl md:hover:scale-105 transition duration-300">
      <div className="md:flex-grow md:h-full md:w-1/4 md:max-h-72 overflow-hidden">
        <img
          src={props.imageUrl}
          alt={props.place}
          className="rounded-t-xl w-full  md:h-full object-cover md:max-h-72"
        />
      </div>
      <div className="md:w-3/5">
        <p className="text-xs">
          ❇ {props.country}{" "}
          <a
            href={props.mapLink}
            target="_blank"
            rel="noreferrer"
            title="Click to view on google maps"
            className="underline"
          >
            View on Google Maps
          </a>
        </p>
        <h1 className="text-2xl font-bold mb-2  active:text-blue-500 text-green-700 transition-colors">
          {props.place}
        </h1>
        <p className="text-sm mb-2 font-bold">{props.dateVisited}</p>
        <p className="md:text-sm">{props.description}</p>
      </div>
    </div>
  );
}

export default Card;
